import { createContext } from 'react'

/** A busca usa o documento já aberto; não baixa outra cópia do PDF. */
export const SearchPanelContext = createContext<HTMLElement | null>(null)
